module.exports = __webpack_public_path__ + "static/Bundle1_AllVinyl-c0a037f315ccdbfa9625cd26e8b82174.png";